import { handleResponse, authHeader } from '../helpers'

export const actionService = {
    getAll,
    update,
    restoreDefaultTemplatesAndAction,
    restoreDefaultTemplateForAction,
    updateTierTemplate,
    updateTemplateOffer,
    retrieve,
}

function getAll (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/actions/all`, requestOptions).then(handleResponse)
}

function update (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/action/update/${params.name}`, requestOptions).then(handleResponse)
}

function restoreDefaultTemplatesAndAction (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/action/restore-actions-defaults`, requestOptions).then(handleResponse)
}
function restoreDefaultTemplateForAction (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/action/restore-action-defaults`, requestOptions).then(handleResponse)
}

function updateTierTemplate (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/action-tier-template/update`, requestOptions).then(handleResponse)
}

function retrieve (name) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    }
    return fetch(`/action/get/${name}`, requestOptions).then(handleResponse)
}

function updateTemplateOffer (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/action-template-offer/update`, requestOptions).then(handleResponse)
}
